// extracted by mini-css-extract-plugin
export var textSliceContent = "Slices-module--textSliceContent--2quZQ";
export var highlightContent = "Slices-module--highlightContent--3J2Mg";